<div class="col-xs-4 col-md-4 col-centered col-slider no-padding row">
  <payment-distribution-schema-form [freighter]="freighter" [schema]="schema" (saved)="onSaved()" (back)="onBack()"></payment-distribution-schema-form>
</div>
